import React from 'react';
import { Spinner } from '@graffer-inc/graffer-ui';

const style = {
  width: '100%',
  height: '100lv',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

const Loading = () => (
  <div style={style}>
    <div className="has-text-centered">
      <Spinner />
    </div>
  </div>
);

export default Loading;
